export default "__VITE_PUBLIC_ASSET__c50f5159__"